import React, { useState } from "react";
import Modal from "../../../parts/modal-new";
import { PRIMARIES, PRIMARIESWITHOLYMPIC } from "../../../constants";

const CollectRepMaxModal = ({ userToBindInformation, notAbleToEdit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenModal = () => setIsOpen((prev) => !prev);
  const { collectRepMax, hideRepMaximums } = userToBindInformation;
  return (
    <>
      <button
        disabled={notAbleToEdit}
        data-button-type="tertiary"
        onClick={(e) => {
          e.preventDefault();
          handleOpenModal();
        }}
      >
        Custom
      </button>
      <Modal
        title={"1 Rep Maxes to Collect"}
        className={isOpen ? "custom-rest-modal" : "!hidden"}
        onClose={(e) => {
          e.preventDefault();
          setIsOpen(false);
        }}
      >
        <div className="body">
          {PRIMARIESWITHOLYMPIC.map((primary) => {
            const defaultChecked =
              collectRepMax?.includes(primary) ||
              (PRIMARIES.includes(primary) &&
                !collectRepMax?.length &&
                !hideRepMaximums);
            return (
              <div
                key={`collect-${primary}`}
                className="flex items-center gap-2"
              >
                <input
                  type="checkbox"
                  name={`collectRepMax[${primary}]`}
                  id={`collectRepMax[${primary}]`}
                  defaultChecked={defaultChecked}
                />
                <label
                  htmlFor={`collectRepMax[${primary}]`}
                  className="capitalize"
                >
                  {primary}
                </label>
              </div>
            );
          })}
        </div>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={handleOpenModal}
          >
            Cancel
          </button>
          <button data-button-type="primary" onClick={handleOpenModal}>
            Save
          </button>
        </footer>
      </Modal>
    </>
  );
};

export default CollectRepMaxModal;
